import FormFields from './FormFields';

class SurveyFormFields extends FormFields {
    logic = { rules: [] };

    constructor(parent, onValidate) {
        super(parent, onValidate, 'data-survey-field-name');
        this.logic = this.parseLogic(parent.dataset.logic);
        this.showSurveyQuestions();
        this.fields.forEach((field) =>
            field.onChange(this.showSurveyQuestions.bind(this))
        );
    }

    parseLogic(encodedLogic) {
        if (!encodedLogic) {
            return { rules: [], numbering: { mode: 'automatic' } };
        }

        try {
            const logic = JSON.parse(atob(encodedLogic));
            return {
                rules: Array.isArray(logic.rules) ? logic.rules : [],
                conditional: Array.isArray(logic.conditional) ? logic.conditional : null,
                numbering: logic.numbering && typeof logic.numbering === 'object' ? logic.numbering : { mode: 'automatic' },
            };
        } catch (error) {
            return { rules: [], numbering: { mode: 'automatic' } };
        }
    }

    showSurveyQuestions() {
        const conditionalQuestions = new Set();
        const fieldByName = new Map();

        this.fields.forEach((field) => {
            fieldByName.set(this.fieldName(field), field);
        });

        if (Array.isArray(this.logic.conditional)) {
            this.logic.conditional.forEach((fieldName) => {
                conditionalQuestions.add(fieldName);
            });
        } else {
            this.logic.rules.forEach((rule) => {
                (rule.then || []).forEach((fieldName) => {
                    conditionalQuestions.add(fieldName);
                });
            });
        }

        this.fields.forEach((field) => {
            if (conditionalQuestions.has(this.fieldName(field))) {
                field.deactivate();
            } else {
                field.activate();
            }
        });

        for (let i = 0; i < this.fields.length; i++) {
            let changed = false;

            this.logic.rules.forEach((rule) => {
                if (!this.ruleMatches(rule)) {
                    return;
                }

                (rule.then || []).forEach((fieldName) => {
                    const field = fieldByName.get(fieldName);

                    if (field && !field.isActive()) {
                        field.activate();
                        changed = true;
                    }
                });
            });

            if (!changed) {
                break;
            }
        }

        this.renumberActiveFields();
    }

    renumberActiveFields() {
        if (this.logic.numbering?.mode === 'manual') {
            return;
        }

        let number = 1;

        this.fields.forEach((field) => {
            if (!field.isActive()) {
                return;
            }

            field.setNumber(number);
            number++;
        });
    }

    ruleMatches(rule) {
        const question = rule.question || '';
        const answers = Array.isArray(rule.answers) ? rule.answers : [];

        if (!question) {
            return false;
        }

        const actualAnswer = this.answerFor(question);

        if (!actualAnswer) {
            return false;
        }

        if (!answers.length) {
            return true;
        }

        return answers.some((answer) => {
            return actualAnswer.includes(this.normalizeAnswer(answer));
        });
    }

    answerFor(fieldName) {
        const data = this.getDataObject();
        const actualAnswer =
            data[this.name + '__' + fieldName] ?? data['survey__' + fieldName] ?? '';

        return this.normalizeAnswer(actualAnswer);
    }

    normalizeAnswer(answer) {
        return String(answer).toLowerCase().trim();
    }

    fieldName(field) {
        return field.getName().replace(this.name + '__', '');
    }

    getRequiredFields() {
        const items = [];
        this.fields.forEach((field) => {
            if (field.isRequired && field.isActive()) {
                items.push(field);
            }
        });
        return items;
    }

    getDataObject() {
        const data = {};
        this.fields.forEach((field) => {
            if (field.isActive()) {
                data[field.getName()] = field.getValue();
            }
        });
        return data;
    }
}

export default SurveyFormFields;
